import classNames from 'classnames';
import { h, JSX } from 'preact';

interface TabItemProps {
    text: string;
    url?: string;
    isActive?: boolean;
}

export interface TabMenuProps {
    items: TabItemProps[];
}

const TabItem = (props: TabItemProps): JSX.Element => (
    <li class={classNames('mr-4', { 'border-b-2 border-neutral-800': props.isActive })}>

        <a
            class={classNames('block py-2.5 font-semibold text-neutral-500 hover:text-neutral-800', { 'text-neutral-800': props.isActive })}
            href={props.url}
        >
            {props.text}
        </a>
    </li>
);

export const TabMenu = (props: TabMenuProps): JSX.Element => (
    <ul class='flex mb-6'>
        {props.items.map((item) => <TabItem {...item} />)}
    </ul>
);
